<template>
  <div v-show="visible" :class="bemBlock" :style="cssCustomProps">
    <div :class="bemElement('thumb')" />
  </div>
</template>

<script>
import bemClassesMixin from '../mixins/bemClassesMixin';

export default {
  name: 'BaseProgressBar',

  mixins: [bemClassesMixin],

  props: {
    container: {
      type: HTMLElement,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      progress: 0,
      resizeObserver: null,
      visible: false,
    };
  },

  computed: {
    cssCustomProps() {
      return {
        '--progress': `${this.progress}%`,
      };
    },
  },

  watch: {
    $windowWidth() {
      this.setInitialState();
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.setInitialState();
      this.container.addEventListener('scroll', this.setProgress, {
        passive: true,
      });
      this.resizeObserver = new ResizeObserver(this.setInitialState);
      // This is the critical part: We observe the size of all children!
      for (let i = 0; i < this.container.children.length; i++) {
        this.resizeObserver.observe(this.container.children[i]);
      }
    });
  },

  beforeDestroy() {
    this.container.removeEventListener('scroll', this.setProgress, {
      passive: true,
    });
    this.resizeObserver.disconnect();
  },

  methods: {
    setInitialState() {
      this.setVisibility();
      this.setProgress();
    },
    setProgress() {
      this.progress =
        ((this.container?.offsetWidth + this.container?.scrollLeft) /
          this.container?.scrollWidth) *
        100;
    },
    setVisibility() {
      this.visible =
        !!this.container &&
        this.container.offsetWidth < this.container.scrollWidth;
    },
  },
};
</script>
